import { combineReducers } from 'redux';

import { reducer as courses } from '@sayyesschool/frontend/features/courses';
import { reducer as enrollments } from '@sayyesschool/frontend/features/enrollments';
import { reducer as learners } from '@sayyesschool/frontend/features/learners';
import { reducer as lessons } from '@sayyesschool/frontend/features/lessons';
import { reducer as managers } from '@sayyesschool/frontend/features/managers';
import { reducer as materials } from '@sayyesschool/frontend/features/materials';
import { reducer as meetings } from '@sayyesschool/frontend/features/meetings';
import { reducer as memberships } from '@sayyesschool/frontend/features/memberships';
import { reducer as packs } from '@sayyesschool/frontend/features/packs';
import { reducer as payments } from '@sayyesschool/frontend/features/payments';
import { reducer as requests } from '@sayyesschool/frontend/features/requests';
import { reducer as rooms } from '@sayyesschool/frontend/features/rooms';
import { reducer as settings } from '@sayyesschool/frontend/features/settings';
import { reducer as tasks } from '@sayyesschool/frontend/features/tasks';
import { reducer as teachers } from '@sayyesschool/frontend/features/teachers';
import { reducer as user } from '@sayyesschool/frontend/features/user';
import { reducer as notification } from '@sayyesschool/frontend/store/features/notification';

export default combineReducers({
    courses,
    enrollments,
    learners,
    lessons,
    managers,
    materials,
    meetings,
    memberships,
    notification,
    packs,
    payments,
    tasks,
    requests,
    rooms,
    settings,
    teachers,
    user
});